
import { dmApi } from "../../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";


export const processingMenuApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        createWasteReturnData: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/processing-data/wr/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['summaryProcessing', 'sortingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data")
            },

        }),
        createProcessingMorningShiftData: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/processing-data/ms/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['morningShift', 'summaryProcessing', 'sortingSummary','processingOvenSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data")
            },

        }),
        updateProcessingMorningShiftData: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/processing-data/ms/${id}/update`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['morningShift', 'summaryProcessing', 'sortingSummary' ,'processingOvenSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data")
            },

        }),
        updateShiftRecord: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/processing-data/shifts/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['shift', 'sortingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Record")
            },
        }),
        createProcessingEveningShiftData: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/processing-data/es/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['eveningShift', 'summaryProcessing', 'sortingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data")
            },

        }),
        updateProcessingEveningShiftData: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/processing-data/es/${id}/update`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['eveningShift', 'summaryProcessing', 'sortingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data")
            },

        }),
        searchMorningShiftData: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/processing-data/ms/logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['morningShift'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getShiftData: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/processing-data/shifts?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['shift'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchEveningShiftData: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/processing-data/es/logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['eveningShift'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
    }),

});

export const {
    useCreateWasteReturnDataMutation,
    useCreateProcessingMorningShiftDataMutation,
    useCreateProcessingEveningShiftDataMutation,
    useSearchEveningShiftDataQuery,
    useSearchMorningShiftDataQuery,
    useGetShiftDataQuery,
    useUpdateShiftRecordMutation,
    useUpdateProcessingMorningShiftDataMutation,
    useUpdateProcessingEveningShiftDataMutation
} = processingMenuApi;

